// The live app, for "View profile" links. Set REACT_APP_APP_URL to the
// deployed Donatella origin; without it those links are hidden rather than
// pointing somewhere wrong.
export const APP_URL = (process.env.REACT_APP_APP_URL ?? "").replace(/\/+$/, "");
